import script from "./FullScreenLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./FullScreenLoader.vue?vue&type=script&setup=true&lang=js"

import "./FullScreenLoader.vue?vue&type=style&index=0&id=5cc68bfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc68bfb"]])

export default __exports__